// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"BackgroundModal_modal_wrapper__JYD4A","modal_title":"BackgroundModal_modal_title__mA9C6","modal_text":"BackgroundModal_modal_text__FC4II"};